"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLocalCity = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var tour_1 = require("../../model/tour");
var service_1 = require("../../../library/base/service");
var GetLocalCity = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetLocalCity, _super);
    function GetLocalCity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '根据经纬度获取城市接口';
        _this.code = '101179';
        _this.desc = '';
        _this.requestParams = new tour_1.GetLocalCityRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetLocalCity;
}(service_1.BaseService));
exports.GetLocalCity = GetLocalCity;
//# sourceMappingURL=getLocalCity.js.map